/**
 * @file jobApplication.ts
 *
 * @fileoverview This file contains the JobApplication related models.
 */

import { JobApplication } from '~/jobiqo/types/types';

/** The GDPRClearingStatus enum contains all GDPR job application statuses. */
export enum GDPRClearingStatusEnum {
  /** The status where job application data was deleted. */
  CLEARED = 'CLEARED',
  /** The status where job application data was not deleted. */
  DEFAULT = 'DEFAULT',
  /** The status where job application data deletion is scheduled. */
  SCHEDULED = 'SCHEDULED',
}

export interface JobApplicationModel extends JobApplication {
  /** The status whether a job application was cleared due to GDPR. */
  cleanupDueToGDPR?: GDPRClearingStatusEnum;
}
